export enum FamilyMemberConfiguration {
    Disabled = 0,
    Enabled = 1
}
